import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../../api/api';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Icon } from '@iconify/react/dist/iconify.js';

const MeetingSheetResultLayer = () => {
    const location = useLocation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const queryParams = new URLSearchParams(location.search);
    const branch = queryParams.get('branch');
    const group = queryParams.get('group');
    const day = queryParams.get('day');
    const type = queryParams.get('type');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const endpoint = type === 'Cash'
                    ? `${API_URL}/meeting-report/cash`
                    : `${API_URL}/meeting-report/product`;

                const res = await axios.post(endpoint, {
                    branch_id: branch,
                    group_id: group,
                    collection_day: day
                });
                console.log(res.data);
                setData(res.data);
            } catch (error) {
                console.error('Error fetching report', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [branch, group, day, type]);

    if (loading) return <p>Loading...</p>;
    if (data.length === 0) return <p>No records found.</p>;

const handleExport = () => {
    if (!data || data.length === 0) return;

    const branchName = data[0]?.branch?.branchname || 'N/A';
    const foName = `${data[0]?.staff?.firstname || ''} ${data[0]?.staff?.lastname || ''}`.trim() || 'N/A';
    const groupName = data[0]?.group?.groupname || 'N/A';
    const dayName = day || 'N/A';

    // 1️⃣ Prepare main data rows
    const exportData = data.map((item, index) => {
        const memberName = `${item.member.firstname} ${item.member.lastname}`;
        const emi = item.loan_amount_with_interest
            ? Number((item.loan_amount_with_interest / item.tenure).toFixed(2))
            : Number((item.loan_amount / item.tenure).toFixed(2));

        return {
            'S.NO': index + 1,
            'Member Name': memberName,
            'Father/Husband Name': item.member.husbandwifename,
            'Mobile No': item.member.mobile,
            'Description': type === 'Cash' ? 'Cash' : item.product?.name || 'Product',
            'Loan Amount': Number(type === 'Cash' ? item.loan_amount_with_interest : item.loan_amount || 0),
            'EMI': emi,
            'Paid': Number(item.payment_received || 0),
            'Today Coll.': '',
            'Remaining': Number(item.balance || 0),
            'Week Remaining':'-',
        };
    });

    // 2️⃣ Header info
    const headerInfo = [
        [`Branch Name: ${branchName}`, '', `FO Name: ${foName}`],
        [`Group Name: ${groupName}`, '', `Collection Day: ${dayName}`],
        [], // blank row
    ];

    const ws = XLSX.utils.aoa_to_sheet(headerInfo);

    // 3️⃣ Add JSON data (with headers)
    XLSX.utils.sheet_add_json(ws, exportData, { origin: -1 });

    // 4️⃣ Determine positions
    const headerRowCount = headerInfo.length;
    const columnHeaderRow = headerRowCount + 1;
    const firstDataRow = columnHeaderRow + 1;
    const lastDataRow = firstDataRow + exportData.length - 1;
    const totalRow = lastDataRow + 1;

    // 5️⃣ Map headers to Excel columns
    const headerKeys = Object.keys(exportData[0]);
    const headerCols = {};
    headerKeys.forEach((key, i) => {
        headerCols[key] = XLSX.utils.encode_col(i);
    });

    // 6️⃣ Add totals label
    ws[`A${totalRow}`] = { t: 's', v: 'Totals' };

    // 7️⃣ Compute totals in JS (static)
    const numericHeaders = ['Loan Amount', 'EMI', 'Paid', 'Remaining', 'Week Remaining'];

    numericHeaders.forEach(headerName => {
        const col = headerCols[headerName];
        if (!col) return;

        const totalValue = exportData.reduce((sum, row) => {
            const val = Number(row[headerName]) || 0;
            return sum + val;
        }, 0);

        ws[`${col}${totalRow}`] = { t: 'n', v: totalValue }; // static number
    });

    // 8️⃣ Update range
    const totalColumns = Object.keys(exportData[0]).length;
    ws['!ref'] = XLSX.utils.encode_range({
        s: { c: 0, r: 0 },
        e: { c: totalColumns - 1, r: totalRow - 1 },
    });

    // 9️⃣ Export workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `${type} Report`);

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const fileName = `${type}_Report_${day}_${group}.xlsx`;
    saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), fileName);
};


    // const handleExport = () => {
    //     if (!data || data.length === 0) return;

    //     const exportData = data.map((item, index) => {
    //         const memberName = `${item.member.firstname} ${item.member.lastname}`;
    //         const emi = item.loan_amount_with_interest
    //             ? (item.loan_amount_with_interest / item.tenure).toFixed(2)
    //             : (item.loan_amount / item.tenure).toFixed(2);

    //         return {
    //             'S.NO': index + 1,
    //             'Member Name': memberName,
    //             'Group Name': item.group.groupname,
    //             'Father/Husband Name': item.member.husbandwifename,
    //             'Mobile No': item.member.mobile,
    //             'Description': type === 'Cash' ? 'Cash' : item.product?.name || 'Product',
    //             'Loan Amount': type === 'Cash' ? item.loan_amount_with_interest : item.loan_amount || 0,
    //             'EMI': emi,
    //             'Paid': item.payment_received || 0,
    //             'Today Coll.': '', // Fill in if you have the logic
    //             'Remaining': item.balance || 0,
    //             'Week Remaining': item.week_remaining || 0,
    //         };
    //     });

    //     const worksheet = XLSX.utils.json_to_sheet(exportData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, `${type} Report`);

    //     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //     const fileName = `${type}_Report_${day}_${group}.xlsx`;

    //     const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    //     saveAs(dataBlob, fileName);
    // };

    return (
        <div className="container py-4">
            <p className="mb-3">📝 {type} Report</p>
            <div className="table-responsive scroll-sm">
                <button
                    onClick={handleExport}
                    className="btn btn-sm btn-success radius-8 d-inline-flex align-items-center gap-1"
                >
                    <Icon icon="simple-line-icons:cloud-download" className="text-xl" />
                    Export to Excel
                </button>
                <table
                    className="table bordered-table text-sm"
                    id="invoice-table"
                >
                    <thead>
                        <tr>
                            <td colSpan="1"></td>
                            <td><b>Branch Name :</b></td>
                            <td><b>{data.length > 0 ? data[0].branch.branchname : branch}</b></td>
                            <td style={{ textAlign: 'center' }}><b>FO Name :</b></td>
                            <td><b>{data.length > 0 ? `${data[0].staff.firstname} ${data[0].staff.lastname}` : 'N/A'}</b></td>
                        </tr>

                        {type === 'Cash' ? (
                            <tr>
                                <th scope="col" className="text-sm">S.NO</th>
                                <th scope="col" className="text-sm">MEMBER</th>
                                <th scope="col" className="text-sm">FATHER/HUSBAND NAME</th>
                                <th scope="col" className="text-sm">MOBILE NO</th>
                                <th scope="col" className="text-sm">Description</th>
                                <th scope="col" className="text-sm">LOAN AMT.</th>
                                <th scope="col" className="text-sm">EMI</th>
                                <th scope="col" className="text-sm">PAID</th>
                                <th scope="col" className="text-sm">Today Coll.</th>
                                <th scope="col" className="text-sm">REMAIN.</th>
                                <th scope="col" className="text-sm">WEEK REMAIN.</th>
                            </tr>
                        ) : (
                            <tr>
                                {/* Customize Product columns here */}
                                <th scope="col" className="text-sm">S.NO</th>
                                <th scope="col" className="text-sm">MEMBER</th>
                                <th scope="col" className="text-sm">FATHER/HUSBAND NAME</th>
                                <th scope="col" className="text-sm">MOBILE NO</th>
                                <th scope="col" className="text-sm">PRODUCT DESC</th>
                                <th scope="col" className="text-sm">TOTAL PRICE</th>
                                <th scope="col" className="text-sm">EMI</th>
                                <th scope="col" className="text-sm">PAID</th>
                                <th scope="col" className="text-sm">Today Coll.</th>
                                <th scope="col" className="text-sm">REMAIN.</th>
                                <th scope="col" className="text-sm">WEEK REMAIN.</th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={item.id || index}>
                                <td>{index + 1}</td>
                                <td>{item.member.firstname} {item.member.lastname} </td>
                                <td>{item.member.husbandwifename}</td>
                                <td>{item.member.mobile}</td>
                                {type === 'Cash' ? (
                                    <>
                                        <td>Cash</td>
                                        <td>{item.loan_amount_with_interest}</td>
                                        <td>{(item.loan_amount_with_interest / item.tenure).toFixed(2)}</td>
                                        <td>{item.payment_received}</td>
                                        <td>{/* Today collection (add your logic) */}</td>
                                        <td>{item.balance}</td>
                                        <td>{item.tenure-item.active_payments_count || 0}</td>
                                    </>
                                ) : (
                                    <>
                                        {/* Example fields for product — adjust according to your API */}
                                        <td>{item.product.name || 'N/A'}</td>
                                        <td>{item.loan_amount || 0}</td>
                                        <td>{(item.loan_amount && item.tenure) ? (item.loan_amount / item.tenure).toFixed(2) : '0.00'}</td>
                                        <td>{item.payment_received || 0}</td>
                                        <td>{/* Today collection (add your logic) */}</td>
                                        <td>{item.balance || 0}</td>
                                        <td>{item.tenure-item.active_payments_count || 0}</td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MeetingSheetResultLayer;
